export default {
  "Fleet_Resdesign_Error_OWDd": "Formato de e-mail inválido",
  "Fleet_Drivers_Please_complete_CZYg": "Preencha todos os campos desta regra primeiro",
  "Fleet_NewPaymentFlow__qbqz": "Valor total recebido",
  "Fleet_NewPaymentFlow__GUTP": "Cobrança única",
  "Fleet_2_To_be_Egnx": "Não vinculado",
  "Fleet_Tool_Links_are_ennN": "Link expirado",
  "Fleet_tittle_The_maximum_tjjA": "O intervalo de tempo máximo é de {{max_time_span}} dias",
  "Fleet_NewPaymentFlow__NhvB": "Valor: {{Price}}. Início da cobrança: {{begin_datetime}}. Frequência: {{Frequency}}.",
  "Fleet_Resdesign_All_XnPT": "Tudo",
  "Fleet_deactivation_sjNc_YjtD": "Cancelar",
  "Fleet_Resdesign_View_Income_PiyV": "Exibir detalhes dos ganhos",
  "Fleet_start__VNTW": "Você não adicionou nenhum carro. Toque em “+ Adicionar carros” para começar a adicionar",
  "Fleet_Resdesign_Thursday_JOxF": "Qui",
  "Fleet_perception__ndnz": "Saiba mais do 99Loc",
  "Fleet_NewPaymentFlow_xuka_dUSy": "Se você mudar para recebimento automático, o aluguel e outras cobranças serão pagas automaticamente da Carteira 99 do motorista. Se não houver saldo suficiente, você precisará cobrar o restante do motorista",
  "Fleet_Drivers_Please_set_HvnQ": "Configure o regime de operação",
  "upt-city---rwrap_fail": {
    "wtext": "Falha ao atualizar",
    "wstext1": "Este modelo não pode ser utilizado.",
    "wstext2": "Erro...",
    "wstext3": "Modificada"
  },
  "Fleet_start_pHZA_kozl": "Tem certeza que deseja sair?",
  "upt-city---search": {
    "city-location-none": "Falha no posicionamento",
    "back": "Voltar",
    "btn-cancel": "Voltar",
    "city-location-title": "Cidade anterior",
    "city-popular-title": "Cidades mais procuradas",
    "data_sub": "Nome da cidade",
    "search-content-title": "Procurar cidade",
    "didi-dialog-p": "Você pode alterar até <em class='org'> {ctime} </em> vezes sua cidade a cada  <em class='org'>6</em>  meses",
    "btn-ok": " Alterar"
  },
  "Fleet_Drivers_Confirm_deletion_aXtK": "Deletar regra agora?",
  "Fleet_optimizaton__GwKg": "Para acessar os recursos “Encontrar motoristas” e “Adicionar motoristas”, os documentos devem ser aprovados primeiro",
  "Fleet_Drivers_Select_Name_OoCI": "Selecione o nome",
  "Fleet_control_ZNQC_ZwIi": "{{Fleet_name}} convidou você para a frota",
  "Fleet_Resdesign_Cash_XfVb": "Dinheiro",
  "GDriver_Enhancement_Repayment_INQd": "Pagar",
  "Fleet_Phase2_Invitation_accepted_jUWV": "Convite aceito",
  "Fleet_Drivers_Verification_code_EAbp": "Código de verificação enviado para {{phone_number}}",
  "Fleet_NewPaymentFlow_svTo_tbpj": "Para alterar o método de recebimento, acesse Meu perfil > Configurações",
  "Fleet_copy_Add_a_QOUx": "Adicionar documentos",
  "Fleet_Resdesign_November_kXkU": "Nov",
  "Fleet_NewPaymentFlow__sJZs": "Convite para alugar um carro",
  "Fleet_NewPaymentFlow__xbNM": "Adicionar nova cobrança",
  "Fleet_NewPaymentFlow__JGoj": "Método de recebimento",
  "Fleet_control_The_total_Mche": "Seu débito em atraso não foi pago e seu saldo será recalculado. Se, posteriormente, o débito em atraso ficar muito alto, nenhum dos motoristas parceiros da frota poderão aceitar corridas em dinheiro até você efetuar o pagamento.",
  "Fleet_Resdesign_Income_summary_PZsP": "Resumo de ganhos",
  "Fleet_NewPaymentFlow__Wzlo": "Configurar o aluguel e outras cobranças",
  "Fleet_MatchingTool_Loading_ingu": "Carregando",
  "Fleet_0303_Fleet_WorkRegime_Weekly_collection_PFfF": "Cobrança toda segunda-feira entre 00:00 e 12:00",
  "upt-city---tips": "Você alterou este dado muitas vezes",
  "Fleet_perception__SzYM": "Desempenho da frota",
  "Fleet_Drivers_Name_can_JcFB": "O campo Nome não pode ficar em branco",
  "Fleet_0303_Fleet_WorkRegime_Enter_name_hIvg": "Selecionar o nome da cobrança",
  "Fleet_Resdesign_No_data_CqQU": "Sem dados",
  "Fleet_Mgt_Question_feedback_uwFO": "Comentários",
  "Fleet_control_mIEb_goHs": "Aceitar",
  "Fleet_NewPaymentFlow_lHPn_FNIg": "Atribua um nome a sua cobrança",
  "Fleet_Resdesign_Saturday_mzeO": "Sáb",
  "Fleet_Mgt__gsvK": "Alugar",
  "Fleet_FleetRecommendation_Successfully_saved_wLuW": "Salvo com sucesso",
  "Fleet_Resdesign_Sunday_jiVr": "Dom",
  "Fleet_0303_Fleet_WorkRegime_everyday_BKeT": "Diária",
  "Fleet_NewPaymentFlow_ecXd_ctUR": "Tipo de cobrança",
  "Fleet_start__EurG": "Você não adicionou nenhum motorista parceiro. Toque no botão abaixo para convidar ou adicionar um",
  "Fleet_Resdesign_Confirmation_McBF": "OK",
  "Fleet_Resdesign_Total_lDoG": "Total de dinheiro recebido",
  "Fleet_NewPaymentFlow__UJcK": "Meus ganhos",
  "Fleet_NewPaymentFlow__djTl": "Total",
  "Fleet_Mgt_No_information_DDuc": "Sem informações",
  "Fleet_Drivers_Add_slkd": "Adicionar",
  "Fleet_Drivers_The_driver_AvoC": "Todos os documentos do motorista foram aprovados!",
  "Fleet_Drivers_Confirmation_jXFy": "Confirmar",
  "Fleet_NewPaymentFlow__Qbnn": "Valor total de cobranças efetivas não recebidas no período selecionado",
  "Fleet_NewPaymentFlow__pMHK": "Extrato",
  "Fleet_control_Please_check_tIFA": "Antes de desvincular este motorista parceiro da sua frota, verifique se ele não tem débitos em atraso. Tem certeza de que quer desvincular este motorista parceiro?",
  "Fleet_Phase1_There_are_TYqj": "Ache motoristas qualificados",
  "Fleet_NewPaymentFlow_utjU_KAIH": "Manual",
  "Fleet_start__OCpm": "Salvo com sucesso",
  "Fleet_NewPaymentFlow__GwuJ": "Observações",
  "Fleet_NewPaymentFlow_BBWr_ImCE": "Este carro tem despesas não pagas. Desvincule o carro do motorista, e então tente deletar o veículo",
  "dinfo---bank": "Conta bancária",
  "Fleet_Resdesign_January_MKno": "Jan",
  "magellan": {
    "martell": {
      "translate": {
        "order_compensate": {
          "driver_channel": {
            "1": "Saldo"
          }
        }
      }
    }
  },
  "Fleet_Tool_Unable_to_jqFL": "Não foi possível sair da frota. Tente novamente mais tarde.",
  "Fleet_Resdesign_Select_End_qdXu": "Hora de término",
  "Fleet_Drivers_Next_step_PxoK": "Próximo",
  "Fleet_copy_Change_UEsW": "Editar",
  "Fleet_NewPaymentFlow__xiMh": "Registrar pagamento",
  "Fleet_Drivers_Rule_number_hDmV": "Regra {{number}}",
  "Fleet_NewPaymentFlow__otGL": "Tudo",
  "Fleet_NewPaymentFlow_TMhC_InJP": "Tem certeza de que deseja deletar este carro?",
  "Fleet_deactivation_DenK_QPgy": "Adicionar novo carro",
  "Fleet_Mgt_Send_a_orZR": "Enviar extrato",
  "Fleet_NewPaymentFlow__GCoA": "Data de ativação",
  "Fleet_start__kQXw": "Ativar o Guia iniciantes",
  "Fleet_NewPaymentFlow__fiLG": "Não recebido",
  "Fleet_NewPaymentFlow__EnGk": "Data de dedução",
  "Fleet_Resdesign_Load_last_YWoz": "Mês anterior",
  "Fleet_Drivers_Add_Rules_KTVL": "Adicionar regra",
  "Fleet_NewPaymentFlow_ebKy_pywA": "Recebido",
  "Fleet_optimizaton__ZYCj": "Adicione carros aqui",
  "Fleet_Drivers_The_driver_wclR": "O motorista entrou em outra frota e não pode ser adicionado",
  "Fleet_start__sbZS": "Voltar",
  "Fleet_start__MHFQ": "Adicionar uma conta bancária",
  "Fleet_Drivers_To_register_MgmZ": "Cadastrar",
  "Fleet_copy_Driver_XTmX": "Motoristas",
  "Fleet_Mgt_Driver_performance_pmda": "Balanço por motorista no período",
  "Fleet_deactivation_AxQl_axxa": "Você não respondeu às mensagens no prazo. Os carros foram removidos.",
  "Fleet_Resdesign_October_pbZU": "Out",
  "Fleet_Resdesign_Enter_email_cylU": "Insira o e-mail",
  "Fleet_Phase1_Driver_Market_lUUD": "Encontrar motoristas",
  "Fleet_FleetRecommendation_Enter_the_Ykpv": "Insira um valor válido",
  "Fleet_Tool_Confirmation_of_xfhT": "Confirmar saída",
  "Fleet_Mgt_Delete_the_cmct": "Deletar este carro?",
  "upt-city---index_city_title": "Alterar cidade",
  "Fleet_Mgt_Select_date_INmY": "Selecionar datas",
  "Fleet_Drivers_The_driver_mSzg": "As regras de trabalho para este motorista foram salvas.",
  "Fleet_MultiUserLogin_Add_succeed_kBCi": "Adicionado com sucesso",
  "Fleet_Drivers_Delete_NcPF": "Deletar",
  "Fleet_perception__LHEy": "(Eu)",
  "Fleet_NewPaymentFlow__ZQOF": "Próximo",
  "Fleet_Drivers_The_invitation_ytYi": "Um link de convite foi enviado ao motorista. Aguarde até que ele aceite.",
  "Fleet_Drivers_Please_help_ZYii": "Para adicionar este motorista, ajude-o a criar um perfil",
  "dinfo---details": {
    "driver_name_title": "Nome",
    "driver_city_title": "Cidade",
    "car_type": "Categoria"
  },
  "Fleet_NewPaymentFlow__AMrP": "Você precisará receber o aluguel e demais cobranças do motorista manualmente",
  "Fleet_start__SeMT": "Convide motoristas parceiros que você conhece com o recurso “Adicionar motoristas”",
  "Fleet_Resdesign_Data_loading_pcxE": "Carregando dados...",
  "Fleet_NewPaymentFlow__VoUq": "Se você desativar esta cobrança, não receberá mais pagamentos a partir do próximo período de cobrança",
  "Fleet_start_DumJ_PRKC": "{{amount}} adicionada(s)",
  "Fleet_Resdesign_April_Qtaf": "Abr",
  "Fleet_0303_Fleet_WorkRegime_Monthly_uzwN": "Mensal",
  "Fleet_optimizaton__AfWb": "Acompanhar a análise",
  "Fleet_Mgt_Vehicle_Details_ihSv": "Detalhes do carro",
  "Fleet_FMS_You_have_pFWa": "Um ou mais campos obrigatórios não foram preenchidos",
  "upt-city---header": " Você pode alterar até {change_time} vezes sua cidade a cada 6 meses",
  "Fleet_Mgt_Pull_down_YzpV": "Arraste para atualizar",
  "Fleet_NewPaymentFlow__TkSG": "Falar com o(a) locador(a)",
  "Fleet_Drivers_Start_date_GZYy": "O campo Data de início não pode ficar em branco",
  "Fleet_Resdesign_Tuesday_UAxw": "Ter",
  "Fleet_Drivers_Frequency_mzAO": "Frequência",
  "Fleet_perception__iBGo": "Desempenho do motorista",
  "Fleet_NewPaymentFlow_sKlJ_uHRX": "Cobrança {{num}}",
  "Fleet_NewPaymentFlow_QOhW_ZVsb": "Desvincular carro?",
  "Fleet_NewPaymentFlow__PsNL": "Valor total a receber",
  "Fleet_NewPaymentFlow__nIsf": "Recebido manualmente",
  "Fleet_NewPaymentFlow_ayYQ_vGUU": "Telefone do motorista",
  "Fleet_NewPaymentFlow_wngD_YWNt": "Em vigor",
  "Fleet_Resdesign_Cash_collection_eETn": "R$ na mão dos(as) motoristas",
  "Fleet_Mgt_Change_color_ddUl": "Alterar cor",
  "Fleet_Tool_Front_Recommended_giVU": "Frotas recomendadas",
  "Fleet_Resdesign_Start_end_Nnvy": "I/F",
  "Fleet_Resdesign_Account_Amount_kIgR": "Saldo online dos(as) motoristas",
  "Fleet_optimizaton__AoyP": "Para usar este recurso, os documentos precisam ser aprovados",
  "Fleet_Tool_Want_to_aUcS": "Quer entrar em outra frota?",
  "Fleet_NewPaymentFlow__wxAJ": "Desempenho por motorista",
  "Fleet_NewPaymentFlow__aQyj": "Adicionar cobranças",
  "balance_v1---withdraw": "Transferir",
  "Fleet_Wording_Balance_YWuq": "Saldo",
  "Fleet_Resdesign_Total_income_hyAh": "Saldo final dos(as) motoristas",
  "Fleet_Resdesign_Withdrawal_records_KMxk": "Repasses 99Loc",
  "Fleet_NewPaymentFlow__oKdN": "Registrar pagamento",
  "Fleet_Drivers_Invitation_to_dIQW": "Convite enviado",
  "Fleet_DriverUnbindFleet_Untied_cPMi": "Desvinculado",
  "Fleet_control_FAQ_djfs": "Central de Ajuda",
  "Fintech_Payment_management_View_the_VZZP": "Ver histórico de saldo",
  "Fleet_Resdesign_Online_SILV": "Online",
  "Fleet_Tool_If_you_dYhg": "Para fazer outra solicitação para deixar a frota, entre em contato com o Atendimento ao Cliente.",
  "Fleet_rental_Week_wLOx": "semana",
  "Fleet_Tool_Untied_successfully_dutX": "Você saiu da frota",
  "Fleet_perception_zHgs_UzNz": "Saldo final",
  "Fleet_Drivers_Enter_the_fNet": "Insira o valor que você receberá deste motorista parceiro na frequência escolhida abaixo",
  "Fleet_Tool_Click_to_DNOM": "Toque para visualizar",
  "Fleet_perception_vSVy_IyMZ": "Pagamentos em dinheiro",
  "Fleet_NewPaymentFlow_owVN_GnVJ": "Método de recebimento das cobranças",
  "Fleet_control_Withdrawal_and_dAGM": "Saque e Histórico de pagamentos",
  "Fleet_Drivers_The_driver_FaYT": "As regras de operação para este motorista foram salvas. Para terminar de adicioná-lo, ajude-o a concluir o cadastro de motorista parceiro",
  "Fleet_Tool_You_have_Trbx": "Sua saída foi concluída. Entre em contato com a frota para devolver o veículo.",
  "Fleet_NewPaymentFlow_fsqE_HdZG": "Não recebido",
  "Fleet_NewPaymentFlow__upZL": "Tipo de cobrança",
  "Fleet_Mgt__Express_dSGM": "{{Express}}",
  "Fleet_NewPaymentFlow__yfXt": "Editar cobrança",
  "Fleet_NewPaymentFlow__ELan": "Data de ativação",
  "Fleet_copy_Deleted_successfully_Mafm": "Removido com sucesso",
  "Fleet_Resdesign_Today_s_yBsy": "Ganhos do motorista",
  "Fleet_control_1_lIfT": "Você está vendo esta mensagem porque sua conta tem débitos em atraso. Isso acontece porque os motoristas parceiros da sua frota estão aceitando mais corridas com pagamento em dinheiro do que com pagamento online, e os pagamentos online recebidos são insuficientes para cobrir as deduções da plataforma devidas por corridas feitas com pagamento em dinheiro. Você pode consultar o total de débitos em atraso acumulados na sua conta ou baixar um relatório para visualizar os de cada motorista.",
  "Fleet_NewPaymentFlow__cQQc": "Não recebido",
  "Fleet_Drivers_Confirm_that_HlwF": "Tem certeza que deseja deletar a regra {{number}}? Uma vez deletada, o conteúdo será perdido.",
  "Fleet_start__JhMH": "Se estiver desativado, você não verá o Guia no início",
  "Fleet_Drivers_Bind_cCCG": "Adicionado",
  "Fleet_Resdesign_December_uJlY": "Dez",
  "Fleet_Drivers_Select_frequency_YcRq": "Selecione a frequência",
  "Fleet_NewPaymentFlow_cfGZ_kjVX": "Para alterar para este método de recebimento é preciso que você primeiro desvincule todos os carros vinculados a motoristas. Acesse a aba “Motoristas”, desvincule-o(a)s, mude o método e volte a vinculá-lo(a)s.",
  "Fleet_Mgt_Loosen_immediately_OZaY": "Solte para atualizar",
  "Fleet_NewPaymentFlow__nJcc": "Todos motoristas",
  "Fleet_start__ikUr": "Liste seu veículo para que os motoristas parceiros que desejam alugar um possam ver",
  "Fleet_Resdesign_Send_csv_ngwh": "Enviar relatório CSV por e-mail",
  "Fleet_MultiUserLogin_Mobile_number_RzUl": "Observação: se você aceitar esse convite, não poderá usar esse número de telefone para se cadastrar como motorista parceiro ou dono de frota.",
  "Fleet_0303_Fleet_WorkRegime_daily_ztIr": "Cobrança diária entre 00:00 e 12:00",
  "Fleet_control_OK_sQYN": "Entendi",
  "Fleet_NewPaymentFlow_mTod_iDbL": "Cobranças totais",
  "Fleet_Drivers_Separation_rules_eXvM": "Regime de operação",
  "Fleet_start_UcCd_UVKp": "{{app_name}}Conecta",
  "Fleet_copy_Remove_vehicle_DDrG": "Remover veículos",
  "Fintech_Payment_Agency__klZT": "Mostrar mais",
  "Fleet_NewPaymentFlow__GiSP": "Data de ativação",
  "Fleet_Drivers_Select_a_yuVt": "A data inicial",
  "Fleet_Drivers_Please_set_YncL": "Configurar regras de operação",
  "Fleet_0303_Fleet_WorkRegime_monthly_XmGW": "Cobrança no primeiro dia do mês entre 00:00 e 12:00",
  "Fleet_NewPaymentFlow__uHzl": "O valor total das cobranças efetivas recebidas no período selecionado. Inclui valores (1) recebidos no app mas não resgatados, (2) recebidos no app e (3) recebidos fora do app e registrados manualmente",
  "Fleet_Phase3_Set_ozBm": "Configurações",
  "Fleet_Resdesign_July_Zroi": "Jul",
  "Fleet_NewPaymentFlow__vurJ": "Aluguel e outras despesas serão deduzidas automaticamente de sua Carteira 99. Se o seu saldo for insuficiente, você precisará pagar o restante ao(a) locador(a)",
  "Fleet_control_The_two_wIUS": "A plataforma aceita dois métodos de pagamento: pagamento com cartão bancário, que normalmente é compensado em 10 minutos, e pagamento fora do aplicativo, que normalmente é compensado em 1 a 2 dias úteis. Para visualizar seu status de pagamento, toque no botão no canto superior direito. Se o pagamento não for depositado até o vencimento, entre em contato com {{mx_contact_info}}",
  "Fleet_NewPaymentFlow__RjDW": "Frequência",
  "Fleet_Resdesign_August_mcie": "Ago",
  "Fleet_NewPaymentFlow__ltIu": "O aluguel e outras cobranças serão recebidas automaticamente da Carteira 99 do motorista. Se a Carteira não tiver saldo suficiente, você precisará cobrar o restante do motorista manualmente",
  "Fleet_NewPaymentFlow__cGLW": "Observe que após aceitar este convite, o(a) locador(a) poderá adicionar ou editar uma despesa sem sua confirmação. Você será informado sobre estas movimentações.",
  "Fleet_Resdesign_Calendar_mFPf": "Agenda",
  "Fleet_start__xLsd": "Ir agora",
  "Fleet_Drivers_Amount_YOtw": "Valor",
  "Fleet_Resdesign__Biaz": "Mar",
  "Fleet_NewPaymentFlow__wclB": "Leia e confirme o aluguel e outras despesas. Toque em Aceitar para iniciar a vigência",
  "Fleet_Resdesign_End_HlIj": "Fim",
  "Fleet_NewPaymentFlow__XoLO": "O valor total das cobranças efetivas no período selecionado",
  "Fleet_NewPaymentFlow__BFLZ": "OK",
  "Fleet_NewPaymentFlow_LJUV_JguU": "Se você mudar para recebimento manual, as despesas não serão deduzidas automaticamente da Carteira 99 do motorista e você precisará cobrar os pagamentos do motorista manualmente",
  "Fleet_Mgt_Are_you_QgSa": "Tem certeza que deseja deletar este carro?",
  "Fleet_Resdesign_Enter_the_ejUB": "Insira um endereço de e-mail para receber seu demonstrativo de ganhos em formato CSV",
  "Fleet_NewPaymentFlow_OSHq_PQkz": "Selecione um carro",
  "Fleet_Drivers_Enter_verification_AAuw": "Insira o código de verificação",
  "Fleet_Drivers_Enter_a_HciF": "Insira um número de telefone válido",
  "Fleet_NewPaymentFlow__ydGV": "Informações da locação",
  "Fleet_control_pbwt_loki": "Agora não",
  "Fleet_deactivation_xUfQ_GyUZ": "Seus carros foram removidos",
  "Fleet_Drivers_Enter_the_WTcT": "Valor que você receberá",
  "Fleet_NewPaymentFlow_gXEl_ipjf": "Não vigente",
  "Fleet_NewPaymentFlow__yzdB": "Detalhes do carro",
  "Fleet_check_vdqm_jUYr": "Não mostrar novamente",
  "Fleet_Resdesign__ucKv": "Mai",
  "Fleet_Drivers_Rules_of_YEUJ": "Regras de operação salvas",
  "Fleet_perception__oMHQ": "Ver detalhes",
  "Fleet_DriverUnbindFleet_Bind_afzf": "Vinculado",
  "Fleet_Drivers_Enter_the_Iqvb": "Insira o número de telefone do motorista",
  "Fleet_Resdesign_Select_Start_CdGi": "Hora de início",
  "Fleet_Resdesign_Income_flow_fcPZ": "Detalhes dos ganhos",
  "Fleet_Resdesign_Heaven_Qvoz": "dia(s)",
  "Fleet_NewPaymentFlow__VAgV": "Mostrar mais",
  "Fleet_Drivers_There_are_mefN": "Algumas regras ainda não foram concluídas. Se você salvar agora, todas as regras incompletas serão perdidas",
  "Fleet_NewPaymentFlow__OPXo": "Desativar esta cobrança?",
  "Fleet_perception__TFIy": "Detalhes dos ganhos",
  "Fleet_Drivers_Confirm_deletion_XNBw": "Deseja deletar a regra {{number}}?",
  "Fleet_Mgt_No_more_mlms": "Fim dos resultados",
  "Fleet_copy_Bind_the_USYf": "Adicionar veículos",
  "Fleet_Drivers_Select_the_njUQ": "O nome da taxa",
  "Fleet_control_GyDm_gKOe": "Falar com o(a) frotista",
  "Fleet_Mgt_Editing_documents_khkk": "Editar documento",
  "Fleet_Resdesign_Total_income_XZbI": "Ganhos totais",
  "Fleet_optimizaton__sPaq": "Os documentos que você enviou ainda estão em análise ou um ou mais documentos não foram aprovados. Você pode abrir o aplicativo para adicionar carros e experimentar vários recursos do produto.",
  "Fleet_NewPaymentFlow_xaDm_BLCM": "Este carro tem despesas pendentes no valor de {{Price}}. Pague o valor primeiro. Se você recebeu o pagamento, pode ajustar o valor manualmente",
  "Fleet_Drivers_The_amount_WtWG": "O campo Valor não pode ficar em branco",
  "Fleet_Mgt_Vehicles_GLnp": "Veículos",
  "Fleet_NewPaymentFlow__znZG": "Este motorista possui cobranças pendentes no valor de {{Price}}. Realize essa cobrança. Se você recebeu o pagamento, registre manualmente no app",
  "Fleet_Drivers_Add_a_rMLY": "Adicionar motorista",
  "Fleet_control2_Are_you_Pujl": "Remover motorista?",
  "Fleet_Drivers_Vehicle_binding_mfjS": "Adicionar veículo",
  "Fleet_Resdesign_Sent_successfully_wwMu": "Enviado com sucesso",
  "Fleet_NewPaymentFlow__PRyq": "Diária",
  "Fleet_Resdesign_June_slTp": "Jun",
  "Fleet_copy_Vehicle_list_PmvG": "A lista de veículos está vazia",
  "Fleet_Resdesign_Page_Name_OKXD": "Início",
  "Fleet_Drivers_Please_set_nduh": "Configurar regime de operação",
  "Fleet_start__dyuk": "Adicionar carros",
  "Fleet_Resdesign_Clear_uVXL": "Limpar",
  "Fleet_Drivers_Mobile_number_sgwd": "Número de telefone",
  "Fleet_Resdesign_Wednesday_IHFc": "Qua",
  "Fleet_NewPaymentFlow__IogO": "Total recebido",
  "Fleet_NewPaymentFlow__zuWo": "Número de telefone do(a) motorista: {{phone_num}}",
  "Fleet_NewPaymentFlow__oIIp": "Extrato",
  "Fleet_perception__gmNA": "Baixar relatório",
  "Fleet_check_GKhX_RGRf": "A foto deve ser bem iluminada e sem filtros",
  "Fleet_Tool_Cancel_axjb": "Cancelar",
  "Fleet_Resdesign_Monday_bazB": "Seg",
  "Fleet_NewPaymentFlow__Khbs": "Automático",
  "Fleet_start__eaYV": "Você pode adicioná-lo novamente a qualquer momento acessando Meu perfil > Configurações",
  "Fleet_Resdesign_Send_IBLm": "Enviar",
  "Fleet_Tool_Confirmation_vzhv": "Sim, sair",
  "Fleet_Drivers_Select_the_tKMG": "Frequência de faturamento",
  "Fleet_Tool_You_need_ewbc": "Confirme em até 7 dias que você deseja sair da frota. Este link expira em 7 dias. Depois desse período, será preciso entrar em contato com o Atendimento ao Cliente novamente.",
  "Fleet_NewPaymentFlow__DRkc": "Desativar cobrança",
  "Fleet_perception_Ferf_lkOZ": "Saldo online motoristas",
  "Fleet_Drivers_Content_may_ZBiI": "O conteúdo pode ser perdido, deseja deletar?",
  "Fleet_Resdesign_Cash_LiLC": "Dinheiro",
  "Fleet_Drivers_Save_feyd": "Salvar",
  "Fleet_Phase1_Go_vwbQ": "Ir",
  "Fleet_Drivers_Daily_00_kmqY": "Diariamente: cobrado todos os dias entre 00:00 e 12:00\nSemanalmente: cobrado todas as segundas-feiras entre 00:00 e 12:00\nMensalmente: cobrado no primeiro dia de cada mês entre 00:00 e 12:00",
  "Fleet_0303_Fleet_WorkRegime_weekly_fELn": "Semanal",
  "Fleet_0303_Fleet_WorkRegime_amount_obtained_otsv": "Insira o valor que você receberá",
  "Fleet_start__rZdn": "Guia para iniciantes",
  "Fleet_Drivers_Are_you_uWrh": "Atenção! Tem certeza que deseja deletar esta regra?",
  "Fleet_NewPaymentFlow__VKFl": "Agora não",
  "Fleet_NewPaymentFlow__MfyW": "{{Fleet_name}} convidou você para alugar um carro",
  "Fleet_start_VrwW_czSn": "Sair",
  "Fleet_Resdesign_Total_tUqe": "A pagar (+)/a receber (-)",
  "Fleet_Resdesign_Slide_more_YbCQ": "Deslize para cima para mais",
  "Fleet_Resdesign_Start_SDWR": "Início",
  "Fleet_Resdesign_September_MGfs": "Set",
  "Fleet_Resdesign_Driver_Summary_zoSe": "Ganho real do motorista",
  "Fleet_payment_Payment_Method_vmsQ": "Método de pagamento",
  "Fleet_NewPaymentFlow__xwbw": "Baixar relatório",
  "Fleet_NewPaymentFlow__owTK": "Selecione um carro para o(a) motorista",
  "Fleet_Resdesign_February_XtXo": "Fev",
  "Fleet_start__pvQo": "0 adicionado",
  "Fleet_start__ASwv": "Ocultar o Guia para iniciantes do início?",
  "Fleet_optimizaton__OUwE": "Documentos em análise",
  "Fleet_NewPaymentFlow_ozwI_goeV": "Desativado",
  "Fleet_start__AAdW": "Convidar motoristas",
  "Fleet_start_aTFD_HHTY": "Sobre",
  "Fleet_NewPaymentFlow__yYUL": "Remover este motorista?",
  "Fleet_Drivers_Return_Driver_SuUV": "Voltar à lista de motoristas",
  "Fleet_NewPaymentFlow__CFxF": "Extrato do(a) motorista",
  "Fleet_NewPaymentFlow__bEhi": "O aluguel e outras despesas serão pagas automaticamente através da Carteira 99",
  "Fleet_NewPaymentFlow__EBXA": "Cobrança manual: você precisará pagar o aluguel e outras despesas ao(a) locador(a) manualmente",
  "Fleet_NewPaymentFlow_FMtz_Fgwk": "Mudar p/ recebimento manual?",
  "Fleet_NewPaymentFlow__xLMz": "O aluguel e outras despesas deverão ser pagas manualmente ao(a) locador(a)",
  "Fleet_Drivers_Cancel_YjzD": "Voltar",
  "Fleet_Drivers_Frequency_can_jPlc": "O campo Frequência não pode ficar em branco",
  "Fleet_NewPaymentFlow_MOPD_sBcZ": "Recebido",
  "Fleet_control2_Vehicles_not_cNeS": "Impossível remover o veículo",
  "Fleet_NewPaymentFlow__HtrY": "Aceitar",
  "Fleet_Resdesign_Save_it_uMek": "Lembrar deste endereço de e-mail?",
  "Fleet_NewPaymentFlow__ZxdF": "Detalhes do valor recebido",
  "Fleet_NewPaymentFlow_ppMF_fAZz": "Desvincular o carro primeiro",
  "Fleet_Drivers_The_driver_haLf": "O motorista não foi adicionado porque tem débitos pendentes",
  "Fleet_NewPaymentFlow__Hecx": "Pular esta etapa",
  "Fleet_Resdesign_Friday_GxZE": "Sex",
  "Fleet_start__ndBl": "Ocultar do início",
  "Fleet_NewPaymentFlow__IqzA": "Extrato por motorista",
  "Fleet_NewPaymentFlow__sXzn": "Editar cobrança",
  "Fleet_copy_No_vehicle_KXvt": "Nenhum veículo adicionado",
  "Fleet_Resdesign_Balance_GHxU": "Perfil",
  "Fleet_NewPaymentFlow__ifcR": "Data de desativação",
  "Fleet_NewPaymentFlow_GZpD_WRgn": "Mudar p/ recebimento automático?",
  "Fleet_perception__mEjw": "Detalhamento de ganhos da frota",
  "Fleet_Drivers_At_the_IfBL": "Data de início",
  "Fleet_NewPaymentFlow__BevI": "Semanal",
  "Fleet_Drivers_Name_nwDP": "Nome",
  "Fleet_control_You_can_UzFy": "Os veículos não podem ser removidos da sua frota até que seus débitos em atraso sejam pagos.",
  "Fleet_Resdesign_Not_selected_xuLq": "Escolha",
  "Fleet_control_Repayment_records_uMeU": "Histórico de reembolsos",
  "Fleet_Drivers_Confirmation_wvYD": "Sim, deletar",
  "Fleet_Mgt_My_driver_nueB": "Motoristas da minha frota",
  "Fleet_Resdesign_Saved_Rbay": "Salvo",
  "Fleet_Mgt_Please_select_zmgM": "Selecione pelo menos um carro",
  "Fleet_perception__akHT": "Você tem débitos em aberto. Para conseguir resgatar seus ganhos, lembre-se de pagá-los em breve. Toque para mais detalhes.",
  "Fleet_Resdesign_Data_loading_WbGr": "Dados carregados",
  "Fleet_NewPaymentFlow_iJcz_jiCd": "Convidando",
  "Fleet_NewPaymentFlow__tgtT": "Aluguel",
  "Fleet_copy_Vehicles_dwty": "Veículos",
  "upt-city---submit": "Alterar cidade",
  "Fleet_start__tmar": "Voltar",
  "Fleet_Drivers_Go_Bind_TxwZ": "Adicionar",
  "Fleet_copy_My_pzKZ": "Meu perfil",
  "Fleet_start_vHHF_ayCO": "Segurança da conta",
  "Fleet_Drivers_Go_Settings_vpjg": "Configurações",
  "Fleet_NewPaymentFlow__WiKw": "Detalhes",
  "Fleet_NewPaymentFlow__eItp": "Recebido",
  "Fleet_Drivers_Settings_zKsG": "Concluído",
  "Fleet_NewPaymentFlow_BoPa_SvIW": "Automático",
  "Fleet_NewPaymentFlow__BVvn": "Manual",
  "Fleet_NewPaymentFlow__gTTE": "Recebido automaticamente",
  "Fleet_NewPaymentFlow__Mhyi": "Deletar",
  "Fleet_Resdesign_Total_unit_iLuD": "Total de corridas",
  "unbindTips": "Tem certeza de que deseja remover o carro? O motorista não poderá usá-lo.",
  "unbindSuccessTips": "Desvinc",
  "my_wallet": "Minha Cart.",
  "bindTips": "Deseja mesmo vincular o carro ao motorista?",
  "bindSuccessTips": "Vinculado",
  "Fleet_check_aUhi_hmNL": "{{brand_name}} needs to access your Photo Album so you can set your profile photo and use other services.",
  "Fleet_check_ejnS_VZqp": "This photo will be your profile photo. We suggest that you:",
  "Fleet_check_OaNq_asGe": "Profile Photo Uploaded",
  "Fleet_check_TNKJ_sfGt": "Don’t wear accessories like hats/sunglasses",
  "Fleet_check_zWwS_DPsT": "Position your face in the center of the screen",
  "Fleet_check_HWak_qoaq": "Upload Profile Photo",
  "Fleet_check_qxdW_jahK": "Keep your face centered",
  "Fleet_issue_eOHq_BsKZ": "Total Tax",
  "Fleet_issue_mmrE_nuXS": "Tax Details",
  "Fleet_check_ELEN_crck": "It typically takes us 24 to 48 hours to review profile photos. We’ll notify you of the review result via SMS and email.",
  "Fleet_check_IYER_eDig": "You can only link vehicles to drivers in your fleet after your profile photo is approved.",
  "Fleet_check_PFze_fown": "Profile Photo Review in Progress",
  "Fleet_check_OZWz_BEqb": "Upload Now",
  "Fleet_check_GbcB_hlpe": "Please upload a profile photo as required below. If your photo is declined, you may not be able to access some features.",
  "Fleet_check_UBBv_ALyB": "Don’t wear accessories",
  "Fleet_check_KSPJ_glKu": "Upload",
  "Fleet_issue_uzuL_mYUR": "We recommend you subtract this amount from the driver’s Total Net Earnings (Before Tax) and Deposits (Before Tax). Tap for more info.",
  "Fleet_check_CBpH_TcGJ": "Choose a simple background, like white",
  "Fleet_issue_wggA_MxPE": "Total Net Earnings (After Tax)",
  "Fleet_issue_aIsE_dmqL": "All Drivers",
  "Fleet_check_uiYb_OxPW": "Your profile photo was declined {{reject_max_time}} times. To use this feature, please upload a valid photo and wait for approval.",
  "Fleet_check_kLTg_CIuk": "Take Photo",
  "Fleet_check_hceA_ycnc": "Got It",
  "Fleet_check_OQKj_GHLS": "You can only link vehicles to drivers after your profile photo is approved.",
  "Fleet_check_fBNK_CTjZ": "You can only invite drivers after your profile photo is approved.",
  "Fleet_issue_sumF_oFSJ": "Generated Tax",
  "Fleet_check_wRSz_suag": "Allow",
  "Fleet_issue_PMnB_Wfat": "Deposits (Before Tax)",
  "Fleet_check_dPXn_jSAI": "Privacy Policy",
  "Fleet_check_pajT_vPwq": "Please Upload a Profile Photo",
  "Fleet_issue_WMHZ_ZyWR": "Total Net Earnings (Before Tax)",
  "Fleet_check_tint_NtpW": "We will notify you of the review result within <span>24 to 48 hours</span> via SMS and email.",
  "Fleet_check_Admw_cABo": "Not Now",
  "Fleet_check_XDUC_GDrR": "Example",
  "Fleet_check_LJzu_FVZT": "Show your full face",
  "Fleet_check_bHXh_cGKL": "Your photo was approved and doesn’t need to be uploaded again",
  "Fleet_check_XKad_fPlI": "Please Re-Upload Profile Photo",
  "GDriver_model__chvL": "Top Up",
  "Fleet_check_iuvA_xbpz": "Upload Profile Photo",
  "Fleet_issue_nMWy_QVYj": "Deposits (After Tax)",
  "Fleet_check_fHaJ_tEra": "Take the photo from the shoulders up",
  "Fleet_check_mDSh_CVHS": "Your photo should meet the following requirements"
}